import {
  FETCH_AGENTS_FAILURE,
  FETCH_AGENTS_REQUEST,
  FETCH_AGENTS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_DEVICES_FAILURE,
  FETCH_DEVICES_REQUEST,
  FETCH_DEVICES_SUCCESS,
  FETCH_DOWNTIME_FAILURE,
  FETCH_DOWNTIME_REQUEST,
  FETCH_DOWNTIME_SUCCESS,
  FETCH_NETWORK_INFO_FAILURE,
  FETCH_NETWORK_INFO_REQUEST,
  FETCH_NETWORK_INFO_SUCCESS,
  FETCH_SPEED_TEST_FAILURE,
  FETCH_SPEED_TEST_REQUEST,
  FETCH_SPEED_TEST_SUCCESS,
  FETCH_TOPOLOGY_FAILURE,
  FETCH_TOPOLOGY_REQUEST,
  FETCH_TOPOLOGY_SUCCESS,
  SET_DEVICE_FILTERS,
  SET_DEVICE_PAGINATION,
  SET_SELECTED_AGENT,
  SET_SELECTED_CUSTOMER,
} from "./types";

const initialState = {
  // Customers
  customers: [],
  customersLoading: false,
  customersError: null,
  selectedCustomer: null,

  // Agents
  agents: [],
  agentsLoading: false,
  agentsError: null,

  // Devices
  devices: [],
  devicesLoading: false,
  devicesError: null,
  devicePagination: {
    page: 1,
    per_page: 20,
    total_pages: 0,
    total_count: 0,
  },
  deviceFilters: {
    status: "",
    device_type: "",
    query: "",
    vendor: "",
    ip_address: "",
  },

  // Device details
  deviceDetails: null,
  deviceDetailsLoading: false,
  deviceDetailsError: null,

  // Topology
  topology: null,
  topologyLoading: false,
  topologyError: null,

  // Connectivity data
  networkInfo: {},
  networkInfoLoading: false,
  networkInfoError: null,

  speedTestData: {},
  speedTestLoading: false,
  speedTestError: null,

  downtimeData: {},
  downtimeLoading: false,
  downtimeError: null,

  // UI state
  selectedAgent: null,

  // General loading state
  isLoading: false,
  error: null,
};

const isightReducer = (state = initialState, action) => {
  switch (action.type) {
    // Customers
    case FETCH_CUSTOMERS_REQUEST:
      return {
        ...state,
        customersLoading: true,
        customersError: null,
      };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload,
        customersLoading: false,
        customersError: null,
      };
    case FETCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        customersLoading: false,
        customersError: action.payload,
      };
    case SET_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
        // Reset agent selection when customer changes
        selectedAgent: null,
      };

    // Agents
    case FETCH_AGENTS_REQUEST:
      return {
        ...state,
        agentsLoading: true,
        agentsError: null,
        isLoading: true,
        error: null,
      };
    case FETCH_AGENTS_SUCCESS:
      return {
        ...state,
        agents: action.payload,
        agentsLoading: false,
        agentsError: null,
        isLoading: false,
        error: null,
      };
    case FETCH_AGENTS_FAILURE:
      return {
        ...state,
        agentsLoading: false,
        agentsError: action.payload,
        isLoading: false,
        error: action.payload,
      };

    // Devices
    case FETCH_DEVICES_REQUEST:
      return {
        ...state,
        devicesLoading: true,
        devicesError: null,
      };
    case FETCH_DEVICES_SUCCESS:
      return {
        ...state,
        devices: action.payload.devices,
        devicePagination: action.payload.pagination,
        devicesLoading: false,
        devicesError: null,
      };
    case FETCH_DEVICES_FAILURE:
      return {
        ...state,
        devicesLoading: false,
        devicesError: action.payload,
      };

    // Topology
    case FETCH_TOPOLOGY_REQUEST:
      return {
        ...state,
        topologyLoading: true,
        topologyError: null,
      };
    case FETCH_TOPOLOGY_SUCCESS:
      return {
        ...state,
        topology: action.payload,
        topologyLoading: false,
        topologyError: null,
      };
    case FETCH_TOPOLOGY_FAILURE:
      return {
        ...state,
        topologyLoading: false,
        topologyError: action.payload,
      };

    // Network info
    case FETCH_NETWORK_INFO_REQUEST:
      return {
        ...state,
        networkInfoLoading: true,
        networkInfoError: null,
      };
    case FETCH_NETWORK_INFO_SUCCESS:
      return {
        ...state,
        networkInfo: {
          ...state.networkInfo,
          [action.payload.agentId]: action.payload.networkInfo,
        },
        networkInfoLoading: false,
        networkInfoError: null,
      };
    case FETCH_NETWORK_INFO_FAILURE:
      return {
        ...state,
        networkInfoLoading: false,
        networkInfoError: action.payload.error,
      };

    // Speed test
    case FETCH_SPEED_TEST_REQUEST:
      return {
        ...state,
        speedTestLoading: true,
        speedTestError: null,
      };
    case FETCH_SPEED_TEST_SUCCESS:
      return {
        ...state,
        speedTestData: {
          ...state.speedTestData,
          [action.payload.agentId]: action.payload.speedTestData,
        },
        speedTestLoading: false,
        speedTestError: null,
      };
    case FETCH_SPEED_TEST_FAILURE:
      return {
        ...state,
        speedTestLoading: false,
        speedTestError: action.payload.error,
      };

    // Downtime
    case FETCH_DOWNTIME_REQUEST:
      return {
        ...state,
        downtimeLoading: true,
        downtimeError: null,
      };
    case FETCH_DOWNTIME_SUCCESS:
      return {
        ...state,
        downtimeData: {
          ...state.downtimeData,
          [action.payload.agentId]: action.payload.downtimeData,
        },
        downtimeLoading: false,
        downtimeError: null,
      };
    case FETCH_DOWNTIME_FAILURE:
      return {
        ...state,
        downtimeLoading: false,
        downtimeError: action.payload.error,
      };

    // UI state
    case SET_SELECTED_AGENT:
      return {
        ...state,
        selectedAgent: action.payload,
      };
    case SET_DEVICE_FILTERS:
      return {
        ...state,
        deviceFilters: { ...state.deviceFilters, ...action.payload },
      };
    case SET_DEVICE_PAGINATION:
      return {
        ...state,
        devicePagination: { ...state.devicePagination, ...action.payload },
      };

    default:
      return state;
  }
};

export default isightReducer;
